import { Fragment, useEffect, useState } from "react";
import { Breadcrumb, Button, Form, Modal } from "react-bootstrap";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { getData, postData } from "../../../api/ApiRest";
import { formatDateddMMMyyyy } from "../../../widgets/DateTime";
import { FaClockRotateLeft, FaMinus, FaPlus } from "react-icons/fa6";
import { formatNumber } from "../../../widgets/FormatNumber";
import { FaCheckCircle, FaSave } from "react-icons/fa";

function ClientesPendientes() {
    const [loading, setLoading] = useState(false);
    const [clientes, setClientes] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [DatosGenerales, setDatosGenerales] = useState([]);
    const [visualizarDetalles, setVisualizarDetalles] = useState({
        ModalVisible: false, Mes: '', Periodo: '', Identificacion: ''
    });
    const [datosModal, setDatosModal] = useState([]);

    const [modalClientesPendientes, setModalClientesPendientes] = useState({
        ModalVisible: false, Titulo: ''
    });

    const [clientesMensuales, setClientesMensuales] = useState([]);

    useEffect(() => {
        visualizarPendientes();
    }, [])

    ///Función para visualizar todos aquellos clientes que están pendientes x generar facturas
    const visualizarPendientes = () => {
        setLoading(true);

        getData('api/Configuracion/Reporte/ClientesPendientes').then(response => {
            setClientes(response.clientes);
            setDatosGenerales(response.datos);
            setClientesMensuales(response.clientesGeneracionMensualidad);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const toggleMostrarHijos = (id) => {
        setExpandedRows((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    ///Función para convertir un # de mes a texto
    const fechaTexto = (mes) => {
        const valores = [
            { key: '1', value: 'Enero' },
            { key: '2', value: 'Febrero' },
            { key: '3', value: 'Marzo' },
            { key: '4', value: 'Abril' },
            { key: '5', value: 'Mayo' },
            { key: '6', value: 'Junio' },
            { key: '7', value: 'Julio' },
            { key: '8', value: 'Agosto' },
            { key: '9', value: 'Septiembre' },
            { key: '10', value: 'Octubre' },
            { key: '11', value: 'Noviembre' },
            { key: '12', value: 'Diciembre' },
        ];

        const mesTexto = valores.filter(x => x.key === String(mes))[0].value;

        return mesTexto;
    }

    ///Función para cargar la info de los documentos de un cliente en un mes especifico
    const cargaInfoClientes = (mes, periodo, identificacion) => {
        setLoading(true);

        getData('api/Configuracion/Reporte/documentosClientes', {
            mes: mes,
            periodo: periodo,
            identificacion: identificacion
        }).then(response => {
            setDatosModal(response.datos);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const generarFacturacionMensual = () => {
        let datos = clientesMensuales.filter(item => item.selected === true);
        const confirmacion = window.confirm('¿Seguro que deseas enviar a facturar todos estos registros?');

        if (!confirmacion)
            return;

        setLoading(true);

        let objecto = [];

        ///Recorremos los clientes y seteamos con los nuevos valores correspondientes a la clase
        for (let i = 0; i < datos.length; i++) {
            let item = datos[i];

            objecto.push({
                identification: item.identificacion,
                nombre: item.nombre
            });
        }

        postData('api/Configuracion/Factura/generarFacturasMasivas', {},
            objecto
        ).then(response => {
            if (response.status) {
                alert('Mensualidades generadas con éxito');
                window.location.reload();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })

    }

    const seleccionaRegistros = (valor) => {
        setClientesMensuales(prev =>
            prev.map(item => ({
                ...item,
                selected: valor
            }))
        )
    }

    const sumatoriaTotal = () => {
        let total = 0;

        clientes.map((item, index) => {
            total += (item.saldo == 0 && item.saldoPg != 0 ? item.saldoPg : item.saldo);
        })

        return total;
    }

    const sumatoriaSaldoAgrupado = () => {
        let total = 0;

        clientesMensuales.map((item, index) => {
            total += item.saldo;
        })

        return total;
    }

    const sumatoriaTotalAgrupado = () => {
        let total = 0;

        clientesMensuales.map((item, index) => {
            total += item.vlrMensual;
        })

        return total;
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/Home/Cartera">Cartera</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Facturación mensual</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <div className="row">
            <div className="col-md-1">
                <button className="btn btn-sm btn-primary" type="button" title="Generar facturación mensual" onClick={() => setModalClientesPendientes({
                    ModalVisible: true, Titulo: 'Clientes pendientes por facturación'
                })}>
                    <FaClockRotateLeft />
                </button>
            </div>
        </div>

        <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Identificación
                            </th>
                            <th className="estilo-encabezado">
                                Cliente
                            </th>
                            <th className="estilo-encabezado">
                                Plan
                            </th>
                            <th className="estilo-encabezado">
                                Fecha inicio
                            </th>
                            <th className="estilo-encabezado">
                                Fecha fin
                            </th>
                            <th className="estilo-encabezado">
                                Saldo
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes.filter(x => x.noVisible != true).map((item, index) => {

                            const valorPinta = DatosGenerales.filter(x => x.identificacion === item.identificacion && x.debeMesActual === 1).length > 0;

                            return (
                                <Fragment key={index}>
                                    <tr style={{ fontSize: 14 }}>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            <Button
                                                style={{
                                                    backgroundColor: "#224B6A",
                                                    color: "rgba(144, 203, 216, 1)",
                                                    fontWeight: "bold",
                                                    textAlign: "center",
                                                    fontSize: 8
                                                }}
                                                onClick={() => toggleMostrarHijos(item.identificacion)}
                                            >
                                                {expandedRows.includes(item.identificacion) ? <FaMinus /> : <FaPlus />}
                                            </Button>
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            {index + 1}
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            {item.identificacion}
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            {item.nombre}
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            {item.plan}
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            {formatDateddMMMyyyy(item.fechaInicio)}
                                        </td>
                                        <td className="text-center" style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent' }}>
                                            {formatDateddMMMyyyy(item.fechaFin)}
                                        </td>
                                        <td style={{ backgroundColor: !valorPinta ? '#F8BEC3' : 'transparent', textAlign: 'right' }}>
                                            $ {item.saldo == 0 && item.saldoPg != 0 ? formatNumber(item.saldoPg) : formatNumber(item.saldo)}
                                        </td>
                                    </tr>

                                    {expandedRows.includes(item.identificacion) && (
                                        <>
                                            <tr className="sub-header">
                                                <th className="text-center"></th>
                                                <th className="text-center"></th>
                                                <th className="text-center">Periodo</th>
                                                <th className="text-center">Mes</th>
                                                <th className="text-center">Cantidad registros</th>
                                                <th className="text-center">Vlr mensual</th>
                                                <th className="text-center"></th>
                                            </tr>

                                            {DatosGenerales.filter(x => x.identificacion === item.identificacion).map((registros, index) => (
                                                <tr key={index} style={{ fontSize: 14 }}>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right' }}></td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right' }}></td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right' }}>{registros.periodo}</td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'left' }}>{fechaTexto(registros.mes)}</td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right', cursor: 'pointer' }} onClick={() => {
                                                        setVisualizarDetalles({
                                                            ModalVisible: true, Mes: fechaTexto(registros.mes), Periodo: registros.periodo, Identificacion: registros.identificacion
                                                        })

                                                        cargaInfoClientes(registros.mes, registros.periodo, registros.identificacion);
                                                    }}>{registros.cantidad_facturas}</td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right' }}>$ {formatNumber(registros.vlrMensual)}</td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right' }}></td>
                                                    <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14, textAlign: 'right' }}></td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </Fragment>);
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th style={{ textAlign: 'center' }}>
                                Total
                            </th>
                            <th style={{ textAlign: 'right' }}>
                                {formatNumber(sumatoriaTotal())}
                            </th>
                        </tr>
                    </tfoot>

                </table>
            </div>
        </div>

        <Modal
            show={visualizarDetalles.ModalVisible}
            size="lg"
            onHide={() => {
                setVisualizarDetalles({ ModalVisible: false, Mes: '', Periodo: '', Identificacion: '' });

                setDatosModal([]);
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{visualizarDetalles.Mes + " - " + visualizarDetalles.Periodo + " / " + visualizarDetalles.Identificacion}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='table-responsive mt-2'>
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado">#</th>
                                <th className="estilo-encabezado">
                                    Documento
                                </th>
                                <th className="estilo-encabezado">
                                    Fecha
                                </th>
                                <th className="estilo-encabezado">
                                    Valor
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {datosModal.map((item, index) => (
                                <tr key={index} style={{ fontSize: 14 }}>
                                    <td style={{ textAlign: 'center' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.prefijo} - {item.numero}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatDateddMMMyyyy(item.fecha)}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        $ {formatNumber(item.valor)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={modalClientesPendientes.ModalVisible}
            size="xl"
            onHide={() => {
                setModalClientesPendientes({ ModalVisible: false, Titulo: '' });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalClientesPendientes.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='table-responsive mt-2'>
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado">#</th>
                                <th className="estilo-encabezado">
                                    Identificación
                                </th>
                                <th className="estilo-encabezado">
                                    Cliente
                                </th>
                                <th className="estilo-encabezado">
                                    Inicio plan
                                </th>
                                <th className="estilo-encabezado">
                                    Fin plan
                                </th>
                                <th className="estilo-encabezado">
                                    Plan
                                </th>
                                <th className="estilo-encabezado">
                                    Vlr mensual
                                </th>
                                <th className="estilo-encabezado">
                                    Saldo
                                </th>
                                <th className="estilo-encabezado" style={{ fontSize: 12 }}>
                                    <button className='btn btn-sm btn-dark' type='button' title='Seleccionar todo' onClick={() => seleccionaRegistros(true)} onDoubleClick={() => seleccionaRegistros(false)}>
                                        <FaCheckCircle size={'1rem'} />
                                    </button>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {clientesMensuales.filter(x => x.noVisible != true).map((item, index) => (
                                <tr key={index} style={{ fontSize: 14 }}>
                                    <td style={{ textAlign: 'center' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{
                                        textAlign: 'center',
                                        fontSize: 14,
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    }} onClick={() => {
                                        window.open('/Home/Empresa/Config/' + item.companyId, '_blank');
                                    }}>
                                        {item.identificacion}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.nombre}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatDateddMMMyyyy(item.fechaInicio)}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatDateddMMMyyyy(item.fechaFin)}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.plan}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        $ {formatNumber(item.vlrMensual)}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        $ {formatNumber(item.saldo)}
                                    </td>
                                    <td className='text-center' style={{ fontSize: 12 }}>
                                        <Form.Check checked={item.selected}
                                            onChange={event =>
                                                setClientesMensuales(
                                                    clientesMensuales.map(p => p.identificacion === item.identificacion ?
                                                        { ...p, selected: !item.selected } : p
                                                    )
                                                )
                                            } />
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th style={{ textAlign: 'center' }}>
                                    Total
                                </th>
                                <th style={{ textAlign: 'right' }}>
                                    {formatNumber(sumatoriaTotalAgrupado())}
                                </th>
                                <th style={{ textAlign: 'right' }}>
                                    {formatNumber(sumatoriaSaldoAgrupado())}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-12">
                        <button type="button" className="btn btn-sm btn-success" title="Generar facturación" onClick={() => generarFacturacionMensual()}>
                            <FaSave />
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </div>
}

export default ClientesPendientes;